import "./App.css";
import Welcome from "./routes/Welcome";
import Forms from "./routes/forms/Forms";
import ICCLRForm from "./routes/forms/ICCLRForm";
import ZVHCForm from "./routes/forms/ZVHCForm";
import ZVHC2Form from "./routes/forms/ZVHC2Form";
import BFC from "./routes/forms/BFC";
import Protehami from "./routes/forms/Protehami";
import InformatieForm from "./routes/forms/InformatieForm";
import Dynamo from "./routes/forms/Dynamo/Dynamo";
import Opzeggingen from "./routes/forms/Opzeggingen";
import Mantelzorg from "./routes/forms/Mantelzorg/Mantelzorg"
import Mantelzorgcompliment from "./routes/forms/Mantelzorgcompliment"
import Noorderkempen from "./routes/forms/Noorderkempen";
import KennemerlandAanmeldformulier from "./routes/forms/KennemerlandAanmeldformulier";
import VisaApplication from "./routes/forms/VisaApplication";
import VIEIntake from "./routes/forms/VIEIntake";

import { useForm } from "react-hook-form";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

function App() {
    const form = useForm();
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Welcome />,
        },
        {
            path: "/forms",
            element: <Forms />,
            children: [
                {
                    path: "/forms/ICCLRF",
                    element: <ICCLRForm {...form} />,
                },
                {
                    path: "/forms/ZVHC",
                    element: <ZVHCForm {...form} />,
                },
                {
                    path: "/forms/ZVHC2",
                    element: <ZVHC2Form {...form} />,
                },
                {
                    path: "/forms/BFC",
                    element: <BFC {...form} />,
                },
                {
                    path: "/forms/Protehami",
                    element: <Protehami {...form} />,
                },
                {
                    path: "/forms/InformatieForm",
                    element: <InformatieForm {...form} />,
                },
                {
                    path: "/forms/Dynamo",
                    element: <Dynamo {...form} />,
                },
                {
                    path: "/forms/Opzeggingen",
                    element: <Opzeggingen {...form} />,
                },
                {
                    path: "/forms/inschrijven-activiteit",
                    element: <Mantelzorg {...form} />,
                },
                {
                    path: "/forms/mantelzorgcompliment",
                    element: <Mantelzorgcompliment {...form} />,
                },
                {
                    path: "/forms/noorderkempen",
                    element: <Noorderkempen {...form} />,
                },
                {
                    path: "/forms/kennemerland-aanmeldformulier",
                    element: <KennemerlandAanmeldformulier {...form} />,
                },
                {
                    path: "/forms/visa-application",
                    element: <VisaApplication {...form} />,
                },
                {
                    path: "/forms/vie-intake",
                    element: <VIEIntake {...form} />,
                },

            ],
        },
    ]);
    return (
        <div className="App">
            <RouterProvider router={router} />
        </div>
    );
}

export default App;
